import { defaultTo } from "lodash";

export interface IAddSalesItemRequest {
    visitId: number;
    salesItemOptionId: number | undefined;
    isPending: boolean;
    salesItemOptionIdBeingReplaced: number | undefined;
    isPackageUpgrade: boolean;
    isFromDI: boolean;
    refillVisitId: number | undefined;
    blockTagAlongs: boolean;
    prescriptionVisitSalesItemId: number | undefined;
    reminderDays: number | undefined;
}

export class AddSalesItemRequest implements IAddSalesItemRequest {
    visitId: number;
    salesItemOptionId: number | undefined;
    isPending: boolean;
    salesItemOptionIdBeingReplaced: number | undefined;
    isPackageUpgrade: boolean;
    isFromDI: boolean;
    refillVisitId: number | undefined;
    blockTagAlongs: boolean;
    prescriptionVisitSalesItemId: number | undefined;
    reminderDays: number | undefined;

    constructor(params: Partial<IAddSalesItemRequest>) {
        this.visitId = defaultTo(params.visitId, 0);
        this.salesItemOptionId = params.salesItemOptionId;
        this.isPending = defaultTo(params.isPending, false);
        this.salesItemOptionIdBeingReplaced = params.salesItemOptionIdBeingReplaced;
        this.isPackageUpgrade = defaultTo(params.isPackageUpgrade, false);
        this.isFromDI = defaultTo(params.isFromDI, false);
        this.refillVisitId = params.refillVisitId;
        this.blockTagAlongs = defaultTo(params.blockTagAlongs, false);
        this.prescriptionVisitSalesItemId = params.prescriptionVisitSalesItemId;
        this.reminderDays = params.reminderDays;
    }
}
